import { useEffect, useState } from "react";
import { billingService } from "../../../Core/Api/services";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import { useNavigate, useParams } from "react-router";
import { routePaths } from "../../../Router/router";
import BillingDetails from "../Details/billing-details";
import { GetInvoiceResponse } from "../../../Core/Api/Types/get-invoice-response";

const BillingInvoiceDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState<GetInvoiceResponse>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!params.invoiceId) {
      navigate(routePaths.billing.path);
      return;
    }

    billingService.GetInvoice(parseInt(params.invoiceId)).then((response) => {
      if (response.invoice) setInvoice(response);
      setLoading(false);
    });
  }, []);

  return (
    <>
      {!loading && <BillingDetails invoice={invoice?.invoice ?? undefined} expenses={invoice?.expenses ?? []} />}
      {loading && <TableSkeleton />}
    </>
  );
};

export default BillingInvoiceDetails;
